/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_Approval_Ask_Tool_Call_Update_BookingInputs */

const en_admin_ai_chat_approval_ask_tool_call_update_booking = /** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Update_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The assistant wants to update a booking.`)
};

const de_admin_ai_chat_approval_ask_tool_call_update_booking = /** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Update_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Assistent möchte eine Buchung ändern.`)
};

const es_admin_ai_chat_approval_ask_tool_call_update_booking = /** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Update_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El asistente quiere actualizar una reserva.`)
};

const fr_admin_ai_chat_approval_ask_tool_call_update_booking = /** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Update_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'assistant souhaite modifier une réservation.`)
};

const nl_admin_ai_chat_approval_ask_tool_call_update_booking = /** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Update_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De assistent wil een boeking wijzigen.`)
};

const it_admin_ai_chat_approval_ask_tool_call_update_booking = /** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Update_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'assistente vuole aggiornare una prenotazione.`)
};

const pt_br2_admin_ai_chat_approval_ask_tool_call_update_booking = /** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Update_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O assistente quer atualizar uma reserva.`)
};

const pl_admin_ai_chat_approval_ask_tool_call_update_booking = /** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Update_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asystent chce zaktualizować rezerwację.`)
};

/** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Update_BookingInputs) => LocalizedString} */
const hu_admin_ai_chat_approval_ask_tool_call_update_booking = en_admin_ai_chat_approval_ask_tool_call_update_booking;

/** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Update_BookingInputs) => LocalizedString} */
const ro_admin_ai_chat_approval_ask_tool_call_update_booking = en_admin_ai_chat_approval_ask_tool_call_update_booking;

/**
* | output |
* | --- |
* | "The assistant wants to update a booking." |
*
* @param {Admin_Ai_Chat_Approval_Ask_Tool_Call_Update_BookingInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_approval_ask_tool_call_update_booking = /** @type {((inputs?: Admin_Ai_Chat_Approval_Ask_Tool_Call_Update_BookingInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_Approval_Ask_Tool_Call_Update_BookingInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_approval_ask_tool_call_update_booking(inputs)
	if (locale === "de") return de_admin_ai_chat_approval_ask_tool_call_update_booking(inputs)
	if (locale === "es") return es_admin_ai_chat_approval_ask_tool_call_update_booking(inputs)
	if (locale === "fr") return fr_admin_ai_chat_approval_ask_tool_call_update_booking(inputs)
	if (locale === "nl") return nl_admin_ai_chat_approval_ask_tool_call_update_booking(inputs)
	if (locale === "it") return it_admin_ai_chat_approval_ask_tool_call_update_booking(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_approval_ask_tool_call_update_booking(inputs)
	if (locale === "pl") return pl_admin_ai_chat_approval_ask_tool_call_update_booking(inputs)
	if (locale === "hu") return hu_admin_ai_chat_approval_ask_tool_call_update_booking(inputs)
	return ro_admin_ai_chat_approval_ask_tool_call_update_booking(inputs)
});
export { admin_ai_chat_approval_ask_tool_call_update_booking as "admin.ai_chat.approval_ask_tool_call.update_booking" }